import { useMutation, useQuery } from "@apollo/client";
import Container from "shared/components/Container";
import graphql from "utils/api/graphql";
import Loading from "shared/components/Loading";
import Error from "shared/components/Error";
import { isEmpty } from "lodash";
import { ADDRESS_TYPES } from "utils/constants";
import { Button } from "antd";

const Open = () => {
  const { data, loading, error } = useQuery(graphql.queries.TOKENS, {
    variables: {
      where: {},
    },
  });
  const [createAddress] = useMutation(graphql.mutations.CREATE_ADDRESS, {
    onCompleted: () => {},
    onError: () => {},
  });

  if (loading) return <Loading />;
  if (error) return <Error />;

  const {
    tokens: { data: tokens },
  } = data;

  return (
    <Container>
      {tokens
        .filter((token) => isEmpty(token.addresses))
        .map((token) => (
          <Button
            key={token.id}
            onClick={() => {
              createAddress({
                variables: {
                  data: {
                    token: { id: token.id },
                    value: "0x7e1d17bea3dd0dd8f3dfc32b1e77ff9ce9e56941",
                    type: ADDRESS_TYPES.RECEIVE,
                  },
                },
              });
            }}
          >
            {token.type}
          </Button>
        ))}
    </Container>
  );
};

export default Open;
